import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./ManageClients.css"; 

const ManageClients = () => {
  const [clients, setClients] = useState([]);
  const [filteredClients, setFilteredClients] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchClients = async () => {
    try {
      setLoading(true);
      const res = await axios.get("https://streamsrvbac.n-tools.info/keymanage/clients/list");
      const data = res.data || [];
      setClients(data);
      setFilteredClients(data);
    } catch (err) {
      console.error("Error fetching clients:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchClients(); }, []);

  useEffect(() => {
    const results = clients.filter((client) =>
      client.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      client.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      client.network_name?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredClients(results);
  }, [searchTerm, clients]);

  return (
    <div className="manage-clients-container">
      {/* HEADER SECTION WITH BACK BUTTON */}
      <div className="manage-clients-header-wrapper" style={{ display: "flex", alignItems: "center", gap: "16px", marginBottom: "24px" }}>
        <button onClick={() => navigate("../")} className="km-back-btn" title="Back to Dashboard">
          ← Back
        </button>
        <div>
          <h2 style={{ margin: 0 }}>Manage Clients</h2>
          <p className="manage-clients-subtitle" style={{ margin: 0 }}>Overview of all registered clients and their status.</p>
        </div>
      </div>

      {/* ACTIONS BAR */}
      <div className="manage-clients-actions-bar">
        <div className="manage-clients-search-box-wrapper">
          <svg className="manage-clients-search-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          <input
            type="text"
            placeholder="Search by name, email, or network..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="manage-clients-search-input"
          />
        </div>
        <button className="manage-clients-btn-add-client" onClick={() => navigate("add")}>
          Add Client
        </button>
      </div>

      {/* TABLE DATA SECTION */}
      {loading ? (
        <div className="manage-clients-loading-wrapper"><div className="manage-clients-spinner"></div><p>Loading database...</p></div>
      ) : (
        <div className="manage-clients-table-wrapper">
          <table className="manage-clients-pro-table">
            <thead>
              <tr>
                <th>ID</th><th>Network</th><th>Client Name</th><th>Contact Info</th><th>Status</th><th style={{ textAlign: "center" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredClients.length > 0 ? (
                filteredClients.map((c) => (
                  <tr key={c.id}>
                    <td className="manage-clients-text-bold">#{c.id}</td>
                    <td><span className="manage-clients-network-badge">{c.network_name || "N/A"}</span></td>
                    <td><span className="manage-clients-name-text">{c.name}</span></td>
                    <td>
                      <div className="manage-clients-contact-cell">
                        <span className="manage-clients-email-text">{c.email}</span>
                        <span className="manage-clients-phone-text">{c.phone || "No Phone"}</span>
                      </div>
                    </td>
                    <td>
                      <span className={`manage-clients-status-badge ${c.status === "inactive" ? "inactive" : "active"}`}>
                        {c.status || "Active"}
                      </span>
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <button className="manage-clients-btn-action-edit" onClick={() => navigate("edit", { state: { client: c } })}>
                        Edit
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr><td colSpan="6" className="manage-clients-no-data-cell">No clients found.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ManageClients;